<template>
    <div class="layout-videos grid grid-cols-1 gap-16 lg:grid-cols-2 xl:grid-cols-3">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutVideos',
};
</script>
